import { memo } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import DashboardIcon from 'components/Icons/DashboardIcon';
import DashboardIconActive from 'components/Icons/DashboardIconActive';
import BlocksIcon from 'components/Icons/BlocksIcon';
import BlocksIconActive from 'components/Icons/BlocksIconActive';
import DimensionsIcon from 'components/Icons/DimensionsIcon';
import DimensionsIconActive from 'components/Icons/DimensionsIconActive';
import ImportDataIcon from 'components/Icons/ImportDataIcon';
import ImportDataIconActive from 'components/Icons/ImportDataIconActive';

import { TabType } from '../types';

interface NavigationBarProperties {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const NavigationBar = memo(({ activeTab, onTabChange }: NavigationBarProperties) => {
  const tabs: {
    key: TabType;
    label: string;
    icon: any;
    activeIcon: any;
  }[] = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      icon: DashboardIcon,
      activeIcon: DashboardIconActive,
    },
    {
      key: 'blocks',
      label: 'Blocks',
      icon: BlocksIcon,
      activeIcon: BlocksIconActive,
    },
    {
      key: 'dimensions',
      label: 'Dimensions',
      icon: DimensionsIcon,
      activeIcon: DimensionsIconActive,
    },
    {
      key: 'import',
      label: 'Data',
      icon: ImportDataIcon,
      activeIcon: ImportDataIconActive,
    },
  ];

  return (
    <Flex
      alignItems='center'
      width='fit-content'
      bg='white'
      borderRadius='12px'
      flexWrap='nowrap'
      overflowX='auto'
      border='1px solid #D9D9D9'
      outline='1px solid #D9D9D9'
      outlineOffset='-1px'
      gap='1px'
      p='0'
    >
      {tabs.map(({ key, label, icon: IconComponent, activeIcon: ActiveIconComponent }) => {
        const isActive = activeTab === key;
        const IconToRender: any = isActive ? ActiveIconComponent : IconComponent;

        return (
          <Flex
            key={key}
            alignItems='center'
            justifyContent='center'
            gap='8px'
            // h='35px'
            px='20px'
            py='8px'
            borderRadius='12px'
            cursor='pointer'
            flexShrink={0}
            bg={isActive ? '#8B5CF6' : 'transparent'}
            color='#121826'
            _hover={{ bg: isActive ? '#8B5CF6' : 'gray.100' }}
            _active={{ bg: isActive ? '#8B5CF6' : 'gray.200' }}
            onClick={() => onTabChange(key)}
          >
            <Box display='flex' alignItems='center' justifyContent='center' w='16px' h='16px'>
              <IconToRender width={16} height={16} />
            </Box>

            <Box
              as='span'
              color={isActive ? 'white' : '#121826'}
              fontSize='13px'
              fontWeight='500'
              lineHeight='1'
              whiteSpace='nowrap'
              textAlign='center'
            >
              {label}
            </Box>
          </Flex>
        );
      })}
    </Flex>
  );
});

NavigationBar.displayName = 'NavigationBar';

export default NavigationBar;
